import script from "./SearchButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchButton.vue?vue&type=script&setup=true&lang=js"

import "./SearchButton.vue?vue&type=style&index=0&id=20335616&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20335616"]])

export default __exports__